import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import './primitives.css';

/**
 * Shimmer block. Size it with width/height (numbers are px) or className.
 *   <Skeleton width={120} height={12} />
 */
export function Skeleton({ width, height = 12, radius, className, style }) {
  return (
    <span
      aria-hidden="true"
      className={cn('is-skeleton', className)}
      style={{ width, height, borderRadius: radius, ...style }}
    />
  );
}

/**
 * Loading placeholder for a data view. Announces "Loading <label>" to
 * screen readers once (role=status), shows skeleton rows by default.
 *
 *   <LoadingState label="breaches" />            // 4 skeleton rows
 *   <LoadingState label="report" variant="spinner" />
 *   <LoadingState rows={8} />
 */
export default function LoadingState({ label = 'content', rows = 4, variant = 'rows', className }) {
  return (
    <div role="status" aria-live="polite" className={className} data-testid="loading-state">
      <span className="sr-only">Loading {label}…</span>
      {variant === 'spinner' ? (
        <div className="is-state is-state--compact" aria-hidden="true">
          <Loader2 size={18} className="is-spinner" style={{ color: 'var(--text-muted)' }} />
          <div className="is-state-text">Loading {label}…</div>
        </div>
      ) : (
        <div className="is-loading-rows" aria-hidden="true">
          {Array.from({ length: rows }).map((_, i) => (
            <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <Skeleton width={`${70 - ((i * 13) % 30)}%`} height={12} />
              <Skeleton width={`${40 + ((i * 17) % 35)}%`} height={10} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
